import { toast } from 'sonner';

const TOAST_DURATION = 1000;

export const showSuccessToast = (title: string, message: string) => {
  toast.success(title, { description: message, duration: TOAST_DURATION });
};

export const showErrorToast = (title: string, message: string) => {
  toast.error(title, { description: message, duration: TOAST_DURATION });
};

export const showWarningToast = (title: string, message: string) => {
  toast.warning(title, { description: message, duration: TOAST_DURATION });
};
